import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { isVisibleOnWeb } from "../../../utils/contentstack/webApplicability.js";
import { FeatureHighlightCardV2UI } from "./FeatureHighlightCardV2UI.js";
import { FeatureHighlightCardV2Skeleton } from "./FeatureHighlightCardV2Skeleton.js";
async function FeatureHighlightCardV2({
  entryId,
  locale,
  enableLivePreview = false,
  entryData,
  analyticsTitlePrefix
}) {
  let data = entryData ?? null;
  if (!data) {
    data = await findOneBusinessEntry(
      ContentType.FeatureHighlightCardV2,
      entryId,
      locale,
      DEFAULT_FIELD_EXCEPTIONS,
      enableLivePreview
    );
  }
  if (!data) {
    return null;
  }
  if (!isVisibleOnWeb(data)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    FeatureHighlightCardV2UI,
    {
      data,
      analyticsTitlePrefix
    },
    entryId
  );
}
export {
  FeatureHighlightCardV2,
  FeatureHighlightCardV2Skeleton,
  FeatureHighlightCardV2UI
};
